<template>
  <span class="special-function-type">{{ keyType }}</span>
</template>
<script>
export default {
  name: 'SpecialFunctionType',
  props: {
    scope: Object,
  },
  computed: {
    keyType() {
      var val = this.$getPropValue(this.scope.row, this.scope.column.property)
      return val
    },
  },
}
</script>
<style lang="less">
.special-function-type {
}
</style>